export default __webpack_public_path__ + "static/media/blog1.03a98fc0.jfif";